export default [
  {
    path: '/b2bhub/Produto',
    name: 'produtos',
    component: () => import('@/views/app/PTC/Produtos/viewProdutos.vue'),
    meta: {
      pageTitle: 'Produtos',
      action: 'read',
      resource: 'Acesso_Produtos',
    },

  },
];
